<template>
  <section class="innovation" id="innovation">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">创新驱动的数字体验创造者</h2>
        <div class="section-description">
          <p>我们专注于通过前沿技术和创新思维，为企业打造卓越的数字体验。从概念设计到最终实现，我们致力于将每一个想法转化为具有影响力的数字解决方案。</p>
          <p>通过深度理解用户需求，结合最新的技术趋势，我们帮助企业在数字化转型的道路上保持领先优势，创造真正有价值的用户体验。</p>
        </div>
      </div>
      
      <div class="innovation-content">
        <div class="innovation-image">
          <div class="image-placeholder">
            <img src="../assets/family.jpg" alt="团队照片" class="family-image" />
          </div>
        </div>
        
        <div class="innovation-features">
          <div class="feature-item" v-for="value in values" :key="value.id">
            <div class="feature-icon" :style="{ background: value.color }">
              <span class="icon">{{ value.icon }}</span>
            </div>
            <div class="feature-content">
              <h3 class="feature-title">{{ value.title }}</h3>
              <p class="feature-description">{{ value.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InnovationSection',
  data() {
    return {
      values: [
        {
          id: 1,
          icon: '💡',
          title: '创新思维',
          description: '不断挑战现状，探索新的解决方案和技术可能性',
          color: '#e0e7ff'
        },
        {
          id: 2,
          icon: '❤️',
          title: '用户至上',
          description: '始终将用户需求放在首位，创造卓越的产品体验',
          color: '#dbeafe'
        },
        {
          id: 3,
          icon: '🤝',
          title: '协作共赢',
          description: '建立开放、协作的工作环境，与客户共同成长',
          color: '#dcfce7'
        },
        {
          id: 4,
          icon: '⭐',
          title: '卓越品质',
          description: '对每一个细节精益求精，追求卓越的产品和服务质量',
          color: '#fef3c7'
        }
      ]
    }
  }
}
</script>

<style scoped>
.innovation {
  padding: 100px 0;
  background: #ffffff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 80px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 32px 0;
  line-height: 1.2;
}

.section-description {
  max-width: 800px;
  margin: 0 auto;
}

.section-description p {
  font-size: 1.125rem;
  line-height: 1.7;
  color: #6b7280;
  margin: 0 0 16px 0;
}

.section-description p:last-child {
  margin-bottom: 0;
}

.innovation-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.innovation-image {
  position: relative;
}

.image-placeholder {
  width: 100%;
  height: 400px;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.family-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
}

.innovation-features {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.icon {
  font-size: 24px;
}

.feature-content {
  flex: 1;
}

.feature-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.feature-description {
  font-size: 1rem;
  line-height: 1.6;
  color: #6b7280;
  margin: 0;
}

@media (max-width: 768px) {
  .innovation {
    padding: 60px 0;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .innovation-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .image-placeholder {
    height: 300px;
  }
  
  .innovation-features {
    gap: 24px;
  }
  
  .feature-item {
    flex-direction: column;
    text-align: center;
    gap: 16px;
    align-items: center;
  }
  
  .feature-icon {
    align-self: center;
  }
  
  .feature-content {
    text-align: center;
  }
}
</style>
